/** @format */

import {styled} from '@mui/material/styles';

const PREFIX = 'CategoryNew';

const classes = {
  infoTitle: `${PREFIX}-infoTitle`,
  infoValue: `${PREFIX}-infoValue`,
  categoryIcon: `${PREFIX}-categoryIcon`,
  categoryTitle: `${PREFIX}-categoryTitle`,
  downloadReportButton: `${PREFIX}-downloadReportButton`,
  categoryDescription: `${PREFIX}-categoryDescription`,
  categorySubtitle: `${PREFIX}-categorySubtitle`,
  infoPlate: `${PREFIX}-infoPlate`,
  graphContainer: `${PREFIX}-container`,
  sensorsCountBox: `${PREFIX}-sensorsCountBox`,
  periodSelectorBox: `${PREFIX}-periodSelectorBox`,
};

const CriteriaRoot = styled('div')(({theme}) => ({
  [`& .${classes.categoryIcon}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '26px',
    height: '26px',
  },

  [`& .${classes.categoryTitle}`]: {
    fontSize: '20px',
    fontWeight: 700,
    margin: theme.spacing(0, 4, 0, 2),
  },

  [`& .${classes.categorySubtitle}`]: {
    color: theme.palette.figma_gray_middle_dark?.main,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 'normal',
  },

  [`& .${classes.downloadReportButton}`]: {
    padding: theme.spacing(4, 8),
    borderRadius: theme.spacing(2),
    background: '#202020',
    boxShadow: '1px 1px 5px 0px rgba(0, 0, 0, 0.05)',
    color: '#F1F1F1',
    fontSize: '14px',
    fontWeight: 400,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginTop: theme.spacing(4),
    },
    '&:hover': {
      background: '#202020',
    },
  },

  [`& .${classes.categoryDescription}`]: {
    padding: theme.spacing(4),
    borderRadius: theme.spacing(2),
    background: '#202020',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '18px',
  },

  [`& .${classes.infoTitle}`]: {
    color: '#8F8F8F',
    fontSize: 14,
    fontWeight: 400,
  },

  [`& .${classes.infoValue}`]: {
    color: theme.palette.text.primary,
    fontSize: 20,
    fontWeight: 500,
    marginTop: theme.spacing(2),
  },

  [`& .${classes.infoPlate}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 'calc(25% - 6px)',
    marginRight: theme.spacing(2),
    padding: theme.spacing(4, 0),
    borderRadius: theme.spacing(2),
    background: '#202020',
    '&:last-of-type': {
      marginRight: 0,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginTop: theme.spacing(2),
      marginRight: 0,
      ['&:first-of-type']: {
        marginTop: 0,
      },
    },
  },

  [`& .${classes.graphContainer}`]: {
    width: '100%',
    height: '340px',
    overflow: 'visible !important',
    paddingTop: `${theme.spacing(8)} !important`,
    paddingBottom: `${theme.spacing(8)} !important`,
    [theme.breakpoints.down('sm')]: {
      paddingTop: 0,
      paddingBottom: 0,
      padding: 0,
    },
  },

  [`& .${classes.sensorsCountBox}`]: {
    mt: 8,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
  },

  [`& .${classes.periodSelectorBox}`]: {
    margin: theme.spacing(12, 0, 8, 0),

    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(8, 0),
    },
  },
}));

export {classes as criteriaClasses, CriteriaRoot};
